// src/index.ts
var whip = "https://remotion.media/whip.wav";
var whoosh = "https://remotion.media/whoosh.wav";
var pageTurn = "https://remotion.media/page-turn.wav";
var uiSwitch = "https://remotion.media/switch.wav";
var mouseClick = "https://remotion.media/mouse-click.wav";
var shutterModern = "https://remotion.media/shutter-modern.wav";
var shutterOld = "https://remotion.media/shutter-old.wav";
var ding = "https://remotion.media/ding.wav";
var bruh = "https://remotion.media/bruh.wav";
var vineBoom = "https://remotion.media/vine-boom.wav";
var windowsXpError = "https://remotion.media/windows-xp-error.wav";
var fah = "https://remotion.media/fah.wav";
var spongebobFail = "https://remotion.media/spongebob-fail.wav";
var omgHellNah = "https://remotion.media/omg-hell-nah.wav";
var priceIsRightFail = "https://remotion.media/price-is-right-fail.wav";
var romanceMeme = "https://remotion.media/romance-meme.wav";
var boneCrack = "https://remotion.media/bone-crack.wav";
var animeWow = "https://remotion.media/anime-wow.wav";
var yippee = "https://remotion.media/yippee.wav";
var loadingLag = "https://remotion.media/loading-lag.wav";
var wilhelmScream = "https://remotion.media/wilhelm-scream.wav";
var macQuack = "https://remotion.media/mac-quack.wav";
var skedaddle = "https://remotion.media/skedaddle.wav";
var snapchatNotification = "https://remotion.media/snapchat-notification.wav";
var nellyAhh = "https://remotion.media/nelly-ahh.wav";
var sanctuaryGuardianWhat = "https://remotion.media/sanctuary-guardian-what.wav";
var minecraftHurt = "https://remotion.media/minecraft-hurt.wav";
var ohMyGodVine = "https://remotion.media/oh-my-god-vine.wav";
var illuminatiConfirmed = "https://remotion.media/illuminati-confirmed.wav";
var dramaticBoomer = "https://remotion.media/dramatic-boomer.wav";
var triggered = "https://remotion.media/triggered.wav";
var recordScratch = "https://remotion.media/record-scratch.wav";
export {
  animeWow,
  boneCrack,
  bruh,
  ding,
  dramaticBoomer,
  fah,
  illuminatiConfirmed,
  loadingLag,
  macQuack,
  minecraftHurt,
  mouseClick,
  nellyAhh,
  ohMyGodVine,
  omgHellNah,
  pageTurn,
  priceIsRightFail,
  recordScratch,
  romanceMeme,
  sanctuaryGuardianWhat,
  shutterModern,
  shutterOld,
  skedaddle,
  snapchatNotification,
  spongebobFail,
  triggered,
  uiSwitch,
  vineBoom,
  whip,
  whoosh,
  wilhelmScream,
  windowsXpError,
  yippee
};
